{
  "bodyInputLabel": "Body",
  "bodyInputPlaceholder": "Describe your issue:",
  "callUs": "Call Us",
  "cancel": "Cancel",
  "chooseYourProduct": "Choose your product",
  "contactUs": "Contact Us",
  "continue": "Continue",
  "createSupportTicketDescription": "Create a support ticket in our system to get direct support from one of our staff.",
  "createSupportTicketHelpContentWithPhoneNumber": "Support tickets are regularly reviewed and addressed by our team. If you prefer to speak to someone, you can call us at {{phoneNumber}}.",
  "createSupportTicketTitle": "Create Support Ticket",
  "emailUs": "Email Us",
  "exitAppPromptMessage": "You are about to navigate to app.farmhq.com to access support documentation.",
  "exitAppPromptTitle": "Continue to FarmHQ Web?",
  "farmHqIsHereToHelp": "FarmHQ is here to help! Contact us with any issues you may have and we will get back to you as soon as possible.",
  "getHelpWithFarmHq": "Get Help with FarmHQ",
  "sendUsAMessage": "Send us a message",
  "shareFeedback": "Share Feedback",
  "shareFeedbackDescription": "Let us know how our product is working for you, and how we can make it work even better.",
  "subjectInputLabel": "Subject",
  "subjectInputPlaceholder": "I need help with...",
  "support": "Support",
  "supportCenter": "Support Center",
  "supportDocumentationLink": "View Support Documentation",
  "title": "Support Center",
  "topic_one": "Topic",
  "topic_other": "Topics",
  "viewInstructionManual": "View Instruction Manual",
  "viewSupportDocsDescription": "Read documentation on installation, troubleshooting, app usage and other issues on app.farmhq.com.",
  "weHaveReceivedYourMessage": "We have received your message!"
}
